import { useState } from 'react';

import { Sentry } from '@/components/Sentry';
import { NarrativeFairValue } from '@/components/NarrativeFairValue';

import { getTradingItemCurrencyISO } from '@/utilities/getTradingItemCurrencyISO';

import type { WatchlistItem } from '@/hooks/useWatchlist';

import { WatchlistNarrativeFairValueModal } from './WatchlistNarrativeFairValueModal';
import { useWatchlistNarrativeFairValue } from './useWatchlistNarrativeFairValue';

export interface Props {
  watchlistId: string;
  watchlistItem: WatchlistItem;
}

export const WatchlistNarrativeFairValue = ({
  watchlistItem,
  watchlistId,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { company } = watchlistItem;

  const narrativeFairValue = useWatchlistNarrativeFairValue({ watchlistItem });

  const companyCurrencyISO =
    getTradingItemCurrencyISO(company.data.currencyInfo) ?? 'XXX';

  if (!watchlistId) return null;

  return (
    <Sentry sentryCapture={{ team: 'narwhals' }} globalDisabled>
      <WatchlistNarrativeFairValueModal
        watchlistItem={watchlistItem}
        watchlistId={watchlistId}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      <NarrativeFairValue
        currencyISO={companyCurrencyISO}
        narrativeFairValue={narrativeFairValue}
        npvPerShare={company.analysisValue?.npvPerShare ?? null}
        onClick={() => setIsModalOpen(true)}
      />
    </Sentry>
  );
};
